module.exports = __webpack_public_path__ + "img/3_sales_navigator.7c8198c6.png";